// extracted by mini-css-extract-plugin
module.exports = {"triggerButton":"ExportBriefsModal_triggerButton__2hoTD","trigger":"ExportBriefsModal_trigger__1qzP6","text":"ExportBriefsModal_text__2GCic"};